import { AuthService } from '../../Services/auth.service';
import { DepartTimeService } from '../../Services/depart-time.service';
import { Component, OnInit } from '@angular/core';
import { IMyDpOptions, IMyMarkedDate, IMyDayLabels } from 'mydatepicker';
import Swal from 'sweetalert2';
import * as $ from 'jquery';

@Component({
  selector: 'app-depart-time-form',
  template: require('./depart-time-form.component.html'),
  styles: [require('./depart-time-form.component.css')]
})
export class DepartTimeFormComponent implements OnInit {
  departTime: any = {}
  AllDepartList: any[] = [];
  leaveHour: number = 8;
  leaveHourMin: number = 0;

  startDate: any;
  endDate: any;
  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
  };

  constructor(private departTimeService: DepartTimeService, private auth: AuthService) { }

  ngOnInit() {
    this.getAllDeparts();
  }

  NewDepart(){
    this.departTime = {
      "id": -1,
      "leaveHour": "",
      "startDate": "",
      "endDate": ""
  }
    var d = new Date();
    this.startDate = {
      jsdate: d,
      date:{year: d.getFullYear(), month: d.getMonth() +1, day: d.getDate()}
    };    
    this.endDate = {
      jsdate: d,
      date:{year: d.getFullYear(), month: d.getMonth() +1, day: d.getDate()}
    };  
    this.leaveHour = 8;
    this.leaveHourMin = 0;
  }

  saveDepart() {
    // var time = new Date(0, 0, 0, this.leaveHour, this.leaveHourMin, 0, 0);
    var time = new Date(Date.UTC(0, 0, 0, this.leaveHour, this.leaveHourMin, 0, 0));
    this.departTime['leaveHour'] = time.toISOString();

    this.departTime.startDate = String(this.startDate.date.year)+"-"+String(this.startDate.date.month)+"-"+String(this.startDate.date.day)
    this.departTime.endDate = String(this.endDate.date.year)+"-"+String(this.endDate.date.month)+"-"+String(this.endDate.date.day)
    // console.log(this.departTime);
    
    this.departTimeService.create(this.departTime).subscribe(x => {
      //  console.log(x);
      this.getAllDeparts();
    })
  }

  deleteDepart(id: number) {
    Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je dit wil verwijderen?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
          this.departTimeService.delete(id).subscribe(x => {
            this.getAllDeparts();
          })
        }
      });
  }

  private getAllDeparts() {
    this.departTimeService.getAllDepartTimes().subscribe(x => {
      this.AllDepartList = x;
      // console.log(this.AllDepartList);
    })
  }

  editDepart(id:number){
    var dep = this.AllDepartList.find( al => al.id == id)
    this.departTime = dep;
    // console.log("this.departTime", this.departTime);
    // console.log("dep",dep);
    

    var t = new Date(this.departTime.leaveHour)
    this.leaveHour = t.getHours()
    this.leaveHourMin = t.getMinutes();

    var b = new Date(this.departTime.startDate);
    this.startDate = {
      jsdate: b,
      date:{year: b.getFullYear(), month: b.getMonth() +1, day: b.getDate()}
    };  

    var e = new Date(this.departTime.endDate);
    this.endDate = {
      jsdate: e,
      date:{year: e.getFullYear(), month: e.getMonth() +1, day: e.getDate()}
    };  
   
    (<any>$('#departModal')).modal();
    
  }
}





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/depart-time-form/depart-time-form.component.ts